import { memo } from 'react';
import { ShieldCheck, Lock, Code2 } from 'lucide-react';
import { TECH_STACK } from '@/src/constants';

function Integrations() {
  return (
    <section className="container mx-auto px-6 py-12 relative z-20">
      <div className="glass-card rounded-3xl p-8 border border-white/10 bg-[#0a0a0a]/50 relative overflow-hidden">
        {/* Background glow */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-900/20 blur-[100px] rounded-full pointer-events-none" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-10 relative z-10">
          {/* Security Column */}
          <div className="md:w-1/3 space-y-4">
            <div>
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <ShieldCheck className="text-green-400" size={24} />
                Enterprise Grade
              </h3>
              <p className="text-gray-400 text-sm mt-2 leading-relaxed">
                Infraestructura diseñada para cumplir con los estándares más estrictos de seguridad
                y privacidad de datos.
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-1.5 text-[10px] font-mono text-green-300 bg-green-900/20 px-2 py-1 rounded border border-green-500/20">
                <Lock size={12} /> SOC2 Type II
              </div>
              <div className="flex items-center gap-1.5 text-[10px] font-mono text-blue-300 bg-blue-900/20 px-2 py-1 rounded border border-blue-500/20">
                <ShieldCheck size={12} /> GDPR Compliant
              </div>
              <div className="flex items-center gap-1.5 text-[10px] font-mono text-purple-300 bg-purple-900/20 px-2 py-1 rounded border border-purple-500/20">
                <Lock size={12} /> E2E Encryption
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px w-full md:w-px md:h-24 bg-gradient-to-r md:bg-gradient-to-b from-transparent via-white/10 to-transparent" />

          {/* Tech Stack Column */}
          <div className="md:w-2/3 w-full">
            <div className="flex items-center justify-between mb-4">
              <span className="text-xs font-bold text-gray-500 uppercase tracking-widest flex items-center gap-2">
                <Code2 size={14} /> Stack Tecnológico
              </span>
              <span className="text-[10px] text-gray-600 font-mono">v2.4.0 COMPATIBLE</span>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {TECH_STACK.map((tech) => (
                <div
                  key={tech.name}
                  className="flex items-center gap-2 px-3 py-2 rounded bg-white/5 border border-white/5 hover:border-white/20 hover:bg-white/10 transition-all cursor-default group"
                >
                  <span className="text-base group-hover:scale-110 transition-transform">
                    {tech.icon}
                  </span>
                  <span className="text-xs text-gray-300 font-medium">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(Integrations);
